import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function PropertySelect(props) {
  const fetch = async (where) => {
    const { properties } = await fetchQuery(
      graphql`
        query PropertySelectQuery($where: PropertyWhere) {
          properties(where: $where, first: 10, orderBy: [name], order: ASC) {
            edges {
              node {
                id
                name
                location {
                  name
                }
              }
            }
          }
        }
      `,
      { where }
    )

    const getText = (node) => {
      return ` ${node.name} - ${node.location.name}`
    }

    return properties.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: getText(node)
    }))
  }

  return (
    <Select
      {...props}
      getByValue={(value) => fetch({ id: { eq: value } })}
      loadOptions={(searchQuery) => fetch({ name: { iLike: `%${searchQuery}%` } })}
    />
  )
}

PropertySelect.defaultProps = {
  label: 'Inmuebles',
  placeholder: 'Inmuebles',
  loadOnMount: false,
}